import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { AuditAction, AuditLog } from '../types';
import { mockAuditLogs } from '../data/mockData';

interface AddAuditInput {
  userId: string;
  userNameAr: string;
  action: AuditAction;
  targetId?: string;
  targetType?: string;
  departmentId?: string;
  metadata?: Record<string, unknown>;
}

interface AuditState {
  logs: AuditLog[];
  add: (input: AddAuditInput) => void;
  byDepartment: (departmentId: string) => AuditLog[];
}

export const useAuditStore = create<AuditState>()(
  persist(
    (set, get) => ({
      logs: mockAuditLogs,
      add: input => set(state => ({
        logs: [{
          id: crypto.randomUUID(),
          ...input,
          createdAt: new Date().toISOString(),
        }, ...state.logs].slice(0, 5000),
      })),
      byDepartment: departmentId => get().logs.filter(log => log.departmentId === departmentId),
    }),
    { name: 'masar-audit' },
  ),
);
